import React from 'react';

import { ImageGallery } from '@rover/react-lib/src/components/ImageGallery';
import {
  GalleryViewMode,
  PaginationConfig,
} from '@rover/react-lib/src/components/ImageGallery/ImageGallery.common';
import useGalleryImages, {
  GALLERY_IMAGE_PAGE_SIZE,
} from '@rover/react-lib/src/pages/sitter-profile/SitterProfilePage/utils/useGalleryImages';
import type { Image as ImageType } from '@rover/rsdk/src/apiClient/latest/model/image';
import { ImageUrls } from '@rover/rsdk/src/apiClient/latest/model/imageUrls';
import { CardGalleryImage } from '@rover/types/src/CardGalleryImages';

const getImageFromGalleryImage = (image): ImageType => {
  return {
    small: image.smallImage,
    smallUncropped: image.smallImage,
    medium: image.largeUncropped,
    mediumUncropped: image.largeUncropped,
    wide: '',
    wideRetina: '',
    largeUncropped: image.largeUncropped,
    largeUncroppedRetina: image.largeUncropped,
    bigThumb: '',
    galleryMain: image.largeUncropped,
    galleryThumb: image.smallImage,
    gallerySmall: image.smallImage,
    gallerySmallWide: image.smallImage,
    isFallback: false,
    originalHeight: 0,
    originalWidth: 0,
    orientation: '',
    url: '',
    urls: [] as unknown as ImageUrls,
    index: 0,
    added: '',
  } as ImageType;
};

type Props = {
  providerOpk: string;
  galleryViewMode: GalleryViewMode;
  lightboxIndex: number;
  setLightboxIndex: React.Dispatch<React.SetStateAction<number>>;
  onClose: () => void;
  onImageClick: (index: number) => void;
  onViewGallery: () => void;
  profileImage: CardGalleryImage;
  initialTotalImageCount: number;
};

const MaximalCardImagesContainer = (props: Props): JSX.Element => {
  const { profileImage, initialTotalImageCount, ...rest } = props;
  const { galleryImages, imageCount, hasMore, isLoadingMore, onPaginate } = useGalleryImages({
    opk: props.providerOpk,
    surface: 'search-card',
  });

  const totalImageCount = Math.max(initialTotalImageCount, imageCount);

  const pagination: PaginationConfig = {
    totalImageCount,
    onLoadMore: onPaginate,
    hasMore,
    isLoadingMore,
    pageSize: GALLERY_IMAGE_PAGE_SIZE,
  };

  return (
    <ImageGallery
      images={[getImageFromGalleryImage(profileImage), ...galleryImages]}
      pagination={pagination}
      {...rest}
    />
  );
};

export default MaximalCardImagesContainer;
